import React, { useState } from 'react'
import { User } from '../../common/types'
import { ActionButtons, FilterModal, ToggleAll } from './components/FilterModal'
import {
  QueryValues,
  TowingJobFilterProvider,
} from './context'
import { JobDayFilter } from './filters/JobDayFilter'
import { JobTypeFilter } from './filters/JobTypeFilter'
import { PriorityFilter } from './filters/PriorityFilter'
import { StationFilter } from './filters/StationFilter'
import { StatusFilter } from './filters/StatusFilter'
import { VisibilityFilter } from './filters/VisibilityFilter'


interface TowingJobFilterProps {
  show?: boolean
  values: QueryValues
  currentUser: User
  resetToDefaultOptions: () => void
  setValues: (values: QueryValues) => void
  loading: boolean
  isDefaultModified?: boolean
  children?: React.ReactNode
}

export const TowingJobFilter = ({
  show,
  currentUser,
  values,
  resetToDefaultOptions,
  setValues,
  loading,
  isDefaultModified,
  children,
}: TowingJobFilterProps) => {
  const [storedInitialValues] = useState(values)

  return show ? (
    <TowingJobFilterProvider
      value={{
        initialValues: storedInitialValues,
        values,
        setValues,
        resetToDefaultOptions,
        loading,
        isDefaultModified: isDefaultModified ? isDefaultModified : false,
        currentUser,
      }}
    >
      {children}
    </TowingJobFilterProvider>
  ) : null
}

export {
  ActionButtons,
  FilterModal,
  JobDayFilter,
  JobTypeFilter,
  PriorityFilter,
  StationFilter,
  StatusFilter,
  ToggleAll,
  VisibilityFilter,
}

// Re-export from context for convenience
export { initialValues, useTowingJobFilterContext, SelectContainer } from './context'
export type { QueryValues, TowingJobStatus } from './context'

export default TowingJobFilter
